<template>
  <div class="add-product">
    <header class="fixed_Back_header flx">
      <div class="menu flx">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#FFF" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
        <h3>Add Product</h3>
      </div>
    </header>

    <section class="main_content addproduct-cnt" ref="s_box">
      <div class="fomr-box">
        <div class="field-row prod-image">
          <div class="upper-part">
            <label class="file">
              <img
                src="../../assets/images/ic_photo.svg"
                class="add-img-icon"
              />
              Add Images(Max8)
              <div class="file-custom">
                <input
                  type="file"
                  id="file"
                  ref="myFiles"
                  accept="video/*,image/*"
                  @change="uploadPhoto"
                  multiple
                />
              </div>
            </label>
          </div>
          <div class="image-preview">
            <ul v-if="imagePreview.length">
              <li v-for="(image, index) in imagePreview" :key="index">
                <img :src="image.small" v-if="image.small" :alt="image" />
                <span class="clear-pic" @click="cutPic(index)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                  >
                    <path
                      fill="#727272"
                      d="M14.513 2.487c-3.315-3.316-8.71-3.316-12.026 0-3.316 3.316-3.316 8.71 0 12.026 3.315 3.316 8.71 3.316 12.026 0 3.316-3.316 3.316-8.71 0-12.026zm-2.66 9.366a.654.654 0 01-.924 0L8.5 9.425l-2.544 2.544a.654.654 0 11-.925-.925L7.575 8.5 5.147 6.07a.654.654 0 11.925-.925L8.5 7.575l2.313-2.313a.654.654 0 11.925.925L9.425 8.5l2.429 2.428a.654.654 0 010 .925z"
                    />
                  </svg>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="field-row">
          <label class="text-label">Product Name</label>
          <input
            type="text"
            name=""
            value=""
            class="input-style"
            placeholder="Product Name"
            v-model="getProductDetail.itemName"
          />
        </div>

        <div class="field-row grid-field">
          <div class="field-col">
            <label class="text-label">MRP</label>
            <input
              type="number"
              name=""
              value=""
              class="input-style"
              placeholder="-"
              v-model="getProductDetail.mrp"
              :disabled='isDisable'
            />
          </div>

          <div class="field-col">
            <label class="text-label">Selling Price</label>
            <input
              type="number"
              name=""
              value=""
              class="input-style"
              placeholder="-"
              v-model="getProductDetail.sellingPrice"
            />
          </div>
        </div>
        <div class="field-row" v-if="!$route.query.productId">
          <label class="text-label">Bar Code (Optional)</label>
          <!-- <input
            style="width:80%;"
            type="number"
            name=""
            value=""
            class="input-style"
            placeholder="Enter BarCode"
            v-model="getProductDetail.upcCode"
          /> -->
          <span
            @click="isScannerOpen = true"
            style="padding: 8px;border: 1px dashed #ccc;border-radius: 7px;width: 50%;display: block;text-align: center;color:#484848;font-size: 0.875em;">
            Scan Bar Code</span
          >
        </div>

        <div class="field-row">
          <label class="text-label">Product Category</label>
          <div class="rel-box">
            <select
              class="select-opt"
              v-model="getProductDetail.rootCategoryId"
              @change="changeFunc()"
              id="selectBox"
            >
              <!-- <option value="Select Category" selected>Select Category</option> -->
              <option
                v-for="(rootCategoryId, index) in allCategories"
                :value="rootCategoryId.id"
                :key="index"
                ><span>{{ rootCategoryId.name }}</span></option
              >
            </select>

            <span class="drop-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="7.41"
                viewBox="0 0 12 7.41"
              >
                <g transform="translate(12) rotate(90)">
                  <path
                    class="a"
                    d="M1.41,0,0,1.41,4.58,6,0,10.59,1.41,12l6-6Z"
                  />
                </g>
              </svg>
            </span>
          </div>
        </div>
        <div class="field-row" :class="{'disable' : !getProductDetail.rootCategoryId || allSubCategories== null}">
          <label class="text-label">Product Subcategory</label>
          <div class="rel-box subcategory">
            <select
              class="select-opt"
              :disabled="!getProductDetail.rootCategoryId || allSubCategories== null"
              v-model="getProductDetail.categoryId"
            >
              <option
                v-for="(categoryId, index) in allSubCategories"
                :value="categoryId.id"
                :key="index"
                ><span>{{ categoryId.name }}</span></option
              >
            </select>
            <span class="drop-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="7.41"
                viewBox="0 0 12 7.41"
              >
                <g transform="translate(12) rotate(90)">
                  <path
                    class="a"
                    d="M1.41,0,0,1.41,4.58,6,0,10.59,1.41,12l6-6Z"
                  />
                </g>
              </svg>
            </span>
          </div>
        </div>

        <div class="field-row grid-field">
          <div class="field-col">
            <label class="text-label">Stock Quantity</label>
            <input
              type="number"
              name=""
              value=""
              class="input-style"
              placeholder="0"
              v-model="getProductDetail.quantity"
            />
          </div>
        </div>

        <div class="field-row">
          <label class="text-label">Product Description</label>
          <textarea
            class="textare-style"
            placeholder="Product Description"
            v-model="getProductDetail.itemDescription"
          ></textarea>
        </div>
      </div>

      <div class="ftr-form">
        <button class="btn" @click="submit()">Submit</button>
      </div>

      <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
      <div class="loader" v-if="loading">
        <img src="../../assets/images/loader.gif" alt="loader" />
      </div>
      <div class="cntntLoad" v-if="blankLoad">
        <img src="../../assets/images/loader.gif" alt="loader" />
      </div>

      <div v-if="isScannerOpen" class="outer-scanner">
        <div class="scanbar-box">
          <bar-code-scanner
            v-if="isScannerOpen && readerSize"
            :readerSize="readerSize"
            isGlobalScanner="true"
            @orderId="getOrderId"
            @closeScanner="isScannerOpen = !isScannerOpen"
          />
          <span class="sanncer-cancle" @click="isScannerOpen=false">Scan Cancel</span>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import '../../assets/css/add-product.scss';
import axios from 'axios';
import ApiCaller from '../../utils/apicaller';
import constant from '../../utils/constant';
import { getBase64Url } from '../../utils/helper';
import CustomToaster from '../Common/CustomToaster';
import ScanBarCode from '@/components/BarCodeScan/ScanBarCode';
import BarCodeScanner from '@/quagga/BarCodeScanner';
export default {
  name: 'AddProduct',
  data() {
    return {
      // feedbackImagePreview: [],
      imagePreview: [],
      allCategories: [],
      allSubCategories: [],
      getProductDetail: {},
      isValidDetail: false,
      toasterData: {},
      loading: false,
      blankLoad: false,
      isScannerOpen: false,
      readerSize: false,
      isDisable: false
    };
  },
  components: {
    BarCodeScanner,
    ScanBarCode,
    CustomToaster,
  },
  watch: {
    // previousImages(val) {
    //   this.imagePreview = this.previousImages;
    //   if (!this.feedbackImagePreview.length) {
    //     this.feedbackImagePreview = [...this.feedbackImagePreview, ...val];
    //   }
    // }
  },
  methods: {
    goBack(){
      let pathvalue;
      if(this.$route.query.CLOUDSHOP){
        pathvalue = `/manage-shops?shopid=${this.$route.query.shopid}&CLOUDSHOP=YES`
      }else{
        pathvalue = `/manage-shops?shopid=${this.$route.query.shopid}`
      }
      this.$router.push(pathvalue)
    },
    getOrderId(_orderId) {
      this.$set(this.getProductDetail, 'upcCode', _orderId);
      this.isScannerOpen = false;
    },
    cutPic(id) {
      // this.feedbackImagePreview.splice(id, 1);
      this.imagePreview.splice(id, 1);
      // this.$emit("uploadImageList", this.imagePreview);
    },
    async uploadPhoto(file) {
      const image = file.target.files[0];
      if (!image.type.includes('image/')) {
        alert('Please select an image file');
        return;
      }
      // getBase64Url(image).then(data => {
      //   this.feedbackImagePreview.push(data);
      // });
      const formData = new FormData();
      this.blankLoad = true;
      formData.append('image', image, image.name);
      formData.append('isResizeRequired', true);
      await axios
        .post(constant.FILE_UPLOAD_URL, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((data) => {
          this.feedbackFile = data.data.mediaVariantDTOs;
          this.blankLoad = false;
          //  this.imagePreview.push(this.feedbackFile);
          let thumbnail = data.data.mediaVariantDTOs.filter(
            (it) => it.size == 'THUMBNAIL'
          );
          let large = data.data.mediaVariantDTOs.filter(
            (it) => it.size == 'LARGE'
          );
          let medium = data.data.mediaVariantDTOs.filter(
            (it) => it.size == 'MEDIUM'
          );
          let original = data.data.mediaVariantDTOs.filter(
            (it) => it.size == 'ORIGINAL'
          );
          let small = data.data.mediaVariantDTOs.filter(
            (it) => it.size == 'SMALL'
          );
          let reqData = {};

          if (thumbnail.length > 0) {
            reqData.thumbnail = thumbnail[0].url;
          }
          if (large.length > 0) {
            reqData.large = large[0].url;
          }
          if (medium.length > 0) {
            reqData.medium = medium[0].url;
          }
          if (original.length > 0) {
            reqData.original = original[0].url;
          }
          if (small.length > 0) {
            reqData.small = small[0].url;
          }
          this.imagePreview.push(reqData);
          console.log(reqData, this.imagePreview)
        })
        .catch((err) => {
          console.log('FAILURE', err);
        });
    },
    getAllCategory() {
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        'get-category-tree/0',
        'get'
      ).then((data) => {
        this.allCategories = data.data.childCategories;
      });
    },
    changeFunc() {
      this.loading = true;
      this.categoryId = '';
      var selectBox = document.getElementById('selectBox');
      var selectedValue = selectBox.options[selectBox.selectedIndex].value;
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        'get-category-tree/' + selectedValue,
        'get'
      )
        .then((data) => {
          this.loading = false;
          this.allSubCategories = data.data.childCategories;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    changeExistCategory(id) {
      this.loading = true;
      // this.categoryId =""
      // var selectBox = document.getElementById("selectBox");
      // var selectedValue = selectBox.options[selectBox.selectedIndex].value;
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        'get-category-tree/' + id,
        'get'
      )
        .then((data) => {
          this.loading = false;
          this.allSubCategories = data.data.childCategories;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getProductDetailById() {
      this.loading = true;
      ApiCaller(
        constant.CATALOGUE_URL,
        'getProductById/' + this.$route.query.productId,
        'get'
      )
        .then((data) => {
          this.loading = false;
          this.getProductDetail = data.data.itemDTOList[0];
          this.$set(this.getProductDetail, 'upcCode', data.data.itemDTOList[0].itemIdentifier)
          this.imagePreview = data.data.itemDTOList[0].itemMediaDTOList;
          this.getProductDetail.rootCategoryId = data.data.rootCategoryId;
          this.getProductDetail.categoryId = data.data.categoryId;
          if((data.data.itemDTOList[0].itemIdentifier.startsWith("LM")) || (data.data.itemDTOList[0].itemIdentifier.startsWith("lm")) && this.$route.query.productId){
            this.isDisable = false
          }else{
            this.isDisable = false
          }
          if (this.getProductDetail.rootCategoryId) {
            this.changeExistCategory(this.getProductDetail.rootCategoryId);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    validateFields() {
      const obj = this.getProductDetail;
      if (
        !this.imagePreview.length ||
        !obj.itemName ||
        !obj.mrp ||
        !obj.sellingPrice ||
        !obj.rootCategoryId ||
        !obj.categoryId ||
        !obj.quantity
      ) {
        this.toasterData = {
          msg: this.$t('enterAllFeilds'),
          color: '#e51c24',
          iconName: 'close',
        };
        this.isValidDetail = true;

        return false;
      } else {
        if (obj.itemName.trim().length >= 4) {
        } else {
          this.toasterData = {
            msg: this.$t('enterValidName'),
            color: '#e51c24',
            iconName: 'close',
          };
          this.isValidDetail = true;
          return false;
        }
        if (obj.quantity === '0') {
          this.toasterData = {
            msg: 'Stock value should be more than 0',
            color: '#e51c24',
            iconName: 'close',
          };
          this.isValidDetail = true;
          return false;
        }
        if (parseFloat(obj.sellingPrice) > parseFloat(obj.mrp)) {
          this.toasterData = {
            msg: 'Selling amount should not be greater than MRP',
            color: '#e51c24',
            iconName: 'close',
          };
          this.isValidDetail = true;
          return false;
        }
        return true;
      }
    },
    submit() {
      if (this.validateFields()) {
        this.loading = true;
        let shopid ;
        console.log(this.getProductDetail.sellerShopId)
        if(this.$route.query.shopid){
          shopid = this.$route.query.shopid
        }else if(this.getProductDetail.sellerShopId){
          shopid = this.getProductDetail.sellerShopId
        }else{
          shopid = null
        }
        const obj = {
          productId: this.getProductDetail.productId,
          productName: this.getProductDetail.itemName,
          description: this.getProductDetail.itemDescription,
          rootCategoryId: Number(this.getProductDetail.rootCategoryId),
          categoryId: Number(this.getProductDetail.categoryId),
          itemDTOList: [
            {
              itemName: this.getProductDetail.itemName,
              itemDescription: this.getProductDetail.itemDescription,
              mrp: Number(this.getProductDetail.mrp),
              sellingPrice: Number(this.getProductDetail.sellingPrice),
              quantity: Number(this.getProductDetail.quantity),
              itemMediaDTOList: this.imagePreview,
              sellerShopId: shopid
            },
          ],
          
        };
        if (this.$route.query.productId) {
          ApiCaller(constant.CATALOGUE_URL, 'update-product', 'post', obj)
            .then((data) => {
              this.loading = false;
              this.$router.go(-1);
            })
            .catch((err) => {
              this.loading = false;
              if (
                err.response.data.errorCodes[0] ==
                'INVALID_PRODUCT_SELLING_PRICE'
              ) {
                this.toasterData = {
                  msg: 'Selling amount should not be greater than MRP',
                  color: '#e51c24',
                  iconName: 'close',
                };
                this.isValidDetail = true;
                return false;
              }else{
                if(err.response.data.message){
                   this.toasterData = {
                  msg: err.response.data.message,
                  color: '#e51c24',
                  iconName: 'close',
                };
                this.isValidDetail = true;
                return false;
                }
               
              }
              
            });
        } else {
          obj.itemDTOList[0].itemIdentifier = this.getProductDetail.upcCode
          ApiCaller(constant.CATALOGUE_URL, 'upload-product', 'post', obj)
            .then((data) => {
              this.loading = false;
              this.$router.go(-1);
            })
            .catch((err) => {
              this.loading = false;
              if (
                err.response.data.errorCodes[0] ==
                'INVALID_PRODUCT_SELLING_PRICE'
              ) {
                this.toasterData = {
                  msg: 'Selling amount should not be greater than MRP',
                  color: '#e51c24',
                  iconName: 'close',
                };
                this.isValidDetail = true;
                return false;
              }
              else if (
                err.response.data.errorCodes[0] == 'SELLER_SHOP_NOT_CREATED'
              ) {
                this.toasterData = {
                  msg: 'Please Create Shop first',
                  color: '#e51c24',
                  iconName: 'close',
                };
                this.isValidDetail = true;
                return false;
              }else{
                if(err.response.data.message){
                   this.toasterData = {
                  msg: err.response.data.message,
                  color: '#e51c24',
                  iconName: 'close',
                };
                this.isValidDetail = true;
                return false;
                }
              }
            });
        }
      }
    },
  },
  mounted() {
    this.readerSize = {
      width: window.innerWidth,
      height: this.$refs['s_box'].offsetHeight,
    };
    this.getAllCategory();
    if (this.$route.query.productId) {
      this.getProductDetailById();
    }
  },
};
</script>
<style scoped>
.disable{
  opacity: 0.75;
}
.outer-scanner {
  width: 100%;
  height: 75vh;
  position: fixed;
  left: 0px;
  top: auto;
  bottom: 0px;
  z-index: 111;
  border-radius: 32px 32px 0 0;
  overflow: hidden;
}

.outer-scanner::before {
  width: 100%;
  height: 100%;
  position: fixed;
  top: auto;
  left: 0;
  bottom: 0px;
  background: rgba(0, 0, 0, 0.9);
  z-index: 11;
  content: '';
}

.outer-scanner .scanbar-box {
  width: 100%;
  position: absolute;
  height: 100%;
  z-index: 111;
}

.outer-scanner .scanbar-box .sanncer-cancle {
  width: 75%;
  height: auto;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: auto;
  bottom: 32px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 0.75em;
  font-weight: 400;
  text-align: center;
  padding: 12px;
  border-radius: 32px;
  text-transform: uppercase;
}
</style>
